import { CustomerManageForm, CustomerManageGrid } from "@/features/manage";
import { filterValidValuesToObject } from "@/shared/lib";
import { vars } from "@/shared/lib/theme.css";
import { CustomerManageSearchType } from "@/shared/model";
import { Column, Indicator } from "@/shared/ui";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/(auth)/_layout/manage/customer-manage/")({
	component: CustomerManagePage,
	validateSearch: (search: Partial<CustomerManageSearchType>): Partial<CustomerManageSearchType> => {
		return filterValidValuesToObject<CustomerManageSearchType, CustomerManageSearchType>(search);
	}
});

function CustomerManagePage() {
	return (
		<Column fullWidth style={{ gap: vars.size[16], paddingBottom: 200 }}>
			<Column
				fullWidth
				style={{
					position: "sticky",
					top: 0,
					zIndex: 100,
					backgroundColor: vars.color.white,
					paddingBottom: vars.size[16]
				}}
			>
				<CustomerManageForm />
			</Column>
			<Suspense fallback={<Indicator />}>
				<CustomerManageGrid />
			</Suspense>
		</Column>
	);
}
